module.exports = __webpack_public_path__ + "static/media/Nobuyuki Umetani.afdac123.png";